<template>
  <SoWidget
    no-padding
    full-height
    :loading="current.meterpoints.isFetching"
    data-testid="last-read-widget"
  >
    <template #title>
      <h6 class="mx-4 mb-4 font-weight-medium">Last Meter Readings</h6>
    </template>
    <template v-for="(meterpoint, index) in sortedMeterpoints" :key="index">
      <LastMeterReadInfo
        v-if="index < showAmount"
        :meterpoint="meterpoint"
        :class="{ 'mb-4': index + 1 === sortedMeterpoints.length }"
        data-testid="last-read-info"
      />
    </template>

    <template #expand>
      <div v-show="showAll">
        <template v-for="(meterpoint, index) in sortedMeterpoints" :key="index">
          <LastMeterReadInfo
            v-if="index >= showAmount"
            :meterpoint="meterpoint"
            data-testid="last-read-hidden"
          />
        </template>
      </div>
    </template>

    <template v-if="sortedMeterpoints.length > showAmount" #actions>
      <SoButton
        :title="showAll ? 'hide' : 'view all'"
        :icon="showAll ? 'chevron-up' : 'chevron-down'"
        type="text"
        @click="showAll = !showAll"
      />
    </template>
    <template
      v-if="!current.meterpoints.isFetching && !(sortedMeterpoints.length > 0)"
    >
      <SoAlert class="mx-4" type="info" data-testid="no-prev-meter-points">
        <p class="text-body-2">No previous meterpoint readings</p>
      </SoAlert>
    </template>
  </SoWidget>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import SoWidget from "@/components/SoWidget.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import LastMeterReadInfo from "../components/LastMeterReadInfo.vue"
  import SoAlert from "@/components/SoAlert.vue"

  export default defineComponent({
    components: {
      SoAlert,
      SoWidget,
      SoButton,
      LastMeterReadInfo,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
        showAmount: 3,
        showAll: false,
      }
    },
    computed: {
      sortedMeterpoints() {
        if (!this.current.meterpoints.isFetched) return []
        return [...this.current.meterpoints.data].sort((a, b) =>
          a.latestRead.date?.isBefore(b.latestRead.date) ? 1 : -1,
        )
      },
    },
  })
</script>
